import { useCallback, useState } from 'react';

import { useLogout } from '@/features/logout';
import { useLoginUserInfo } from '@/hooks/useLoginUserInfo';
import { removeBeforeunloadEvent } from '@/utils';

/**
 * ヘッダー > メインメニュー > ログアウトメニュー用 hooks
 *
 * @returns
 */
export const useLogoutContainer = () => {
  const { doLogoutForPTID, logoutRedirectStatus } = useLogout({
    onSuccessFun: removeBeforeunloadEvent, // beforeunloadイベントによるwindows.alert削除
  });
  const { isSerialPlan } = useLoginUserInfo();
  /**
   * ログアウト確認ダイアログを表示するか否か(true=表示)
   */
  const [shouldOpenLogoutDialog, setShouldOpenLogoutDialog] =
    useState<boolean>(false);

  /**
   * [ログアウト]メニューをクリックした場合の処理
   */
  const onClickLogoutMenu = useCallback(
    (closeMenu: () => void) => {
      // メニュー閉じる
      closeMenu();

      if (isSerialPlan) {
        // シリアルで利用中はログアウト確認ダイアログを表示
        setShouldOpenLogoutDialog(true);
      } else {
        // PTIDで利用中はログアウト確認ダイアログを表示せずにログアウト実行
        doLogoutForPTID();
      }
    },
    [doLogoutForPTID, isSerialPlan],
  );

  return {
    // ログアウト確認ダイアログを表示するか否か(true=表示)
    shouldOpenLogoutDialog,
    // [ログアウト]メニューをクリックした場合の処理
    onClickLogoutMenu,
    // ログアウトAPI(リダイレクト用)呼び出し状況
    logoutRedirectStatus,
  };
};
